// extracted by mini-css-extract-plugin
module.exports = {"note":"Attachment_note__3Er94"};